<template>
    <div class="goldMedal">
        <div class="goldMedal-bg"></div>

        <div class="goldMedal-content">
            <div class="goldMedal-close" @click="handleClose"></div>
            <div :class="goldMedalIcon"></div>
            <div class="goldMedal-title">恭喜你获得</div>
            <div :class="goldMedalDesc"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'goldMedal',
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        goldMedalIcon() {
            const { type = '' } = this.data;
            if(type === 'gold') {
                return 'goldMedal-icon'
            } else if (type === 'sliver') {
                return 'sliverMedal-icon'
            } else if( type === 'bronze') {
                return 'bronzeMedal-icon'
            } else {
                return ''
            }
        },
        goldMedalDesc() {
            const { type = '' } = this.data;
            if(type === 'gold') {
                return 'goldMedal-desc'
            } else if (type === 'sliver') {
                return 'sliverMedal-desc'
            } else if( type === 'bronze') {
                return 'bronzeMedal-desc'
            } else {
                return ''
            }
        }
    },
    methods: {
        handleClose() {
            // TODO:
            this.$emit('close')
        }
    }
}
</script>

<style scoped lang="scss">
.goldMedal {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 101;
    .goldMedal-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.56);
        position: absolute;
        left: 0;
        top: 0;
    }
    .goldMedal-content {
        width: 526px;
        height: 600px;
        background: url('~@/assets/img/answer/answer-gold-bg.png') no-repeat;
        background-size: cover;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .goldMedal-close {
        width: 42px;
        height: 42px;
        background: url('~@/assets/img/answer/answer-close-btn.png') no-repeat center;
        background-size: cover;
        position: absolute;
        top: -30px;
        right: -78px;
        cursor: pointer;
    }
    .goldMedal-icon{
        width: 526px;
        height: 570px;
        background: url('~@/assets/img/answer/answer-gold-icon.png') no-repeat center;
        background-size:cover ;
    }
    .sliverMedal-icon{
        width: 526px;
        height: 570px;
        background: url('~@/assets/img/answer/answer-sliver-icon.png') no-repeat center;
        background-size:cover ;
    }
    .bronzeMedal-icon{
        width: 526px;
        height: 570px;
        background: url('~@/assets/img/answer/answer-bronze-icon.png') no-repeat center;
        background-size:cover ;
    }
    .goldMedal-title {
        position: absolute;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #000000;
        text-align: center;
        bottom: 127px;
        left: 50%;
        transform: translateX(-50%);
    }
    .goldMedal-desc {
        width: 424px;
        height: 42px;
        background: url('~@/assets/img/answer/answer-gold-title.png') no-repeat center;
        background-size: cover;
        position: absolute;
        bottom: 56px;
        left: 50%;
        transform: translateX(-50%);
    }
    .sliverMedal-desc {
        width: 424px;
        height: 42px;
        background: url('~@/assets/img/answer/answer-sliver-title.png') no-repeat center;
        background-size: cover;
        position: absolute;
        bottom: 56px;
        left: 50%;
        transform: translateX(-50%);
    }
    .bronzeMedal-desc {
        width: 424px;
        height: 42px;
        background: url('~@/assets/img/answer/answer-bronze-title.png') no-repeat center;
        background-size: cover;
        position: absolute;
        bottom: 56px;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
